<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="40%"
    class="addTemplateActivityDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" :disabled="editable" label-position="left" ref="addTemplateActivityFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="活动分类" prop="activityClassificationCode">
            <el-radio-group v-model="formData.activityClassificationCode" @change="changeTemplateType">
              <el-radio :label="item.value" v-for="(item,index) in activityClassificationList" :key="index">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="活动模板名称" prop="templateName">
            <el-input v-model="formData.templateName" :readonly="formData.activityClassificationCode === 'AC_02'"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工具包链接">
            <el-input v-model="formData.sourceLink" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="活动目的">
            <el-select v-model="formData.activityGoal" placeholder="请选择" clearable>
              <el-option v-for="item in activityGoalList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldValue" />
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="可见范围" prop="visibleRangeSelect" v-if="formData.activityClassificationCode === 'AC_01'">
            <el-checkbox-group
              v-model="formData.visibleRangeSelect"
              @change="visibleRangeSelectChange"
            >
              <el-checkbox
                v-for="item in visibleRangeList"
                :key="item.fieldKey"
                :label="item.fieldKey"
              >
                {{ item.fieldValue }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="活动议程" v-if="formData.activityClassificationCode === 'AC_01'">
            <!-- <el-tag
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)">
              {{tag}}
            </el-tag> -->
            <div class="agendaRow" v-for="(item,index) in agendaList.length" :key="index">
              <el-input v-model="agendaList[index]"/>
              <el-button v-show="agendaList.length > 1" type="text" @click="agendaDelBtn(index)">删除</el-button>
            </div>
            <el-button type="text" @click="agendaAddBtn">添加</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row> -->
      <!--        <el-col :span="16">-->
      <!--          <el-form-item label="活动类型">-->
      <!--            <el-select v-model="formData.activityTypeCode" placeholder="请选择" @change="activityTypeChange" clearable>-->
      <!--              <el-option v-for="item in activityTypeList" :key="item.id" :label="item.typeName" :value="item.id" />-->
      <!--            </el-select>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--      <el-row>-->
      <!--        <el-col :span="16">-->
      <!--          <el-form-item label="细分活动类型">-->
      <!--            <el-select v-model="formData.activitySubtypeCode" placeholder="请选择" clearable>-->
      <!--              <el-option v-for="item in subdivideTypeList" :key="item.id" :label="item.typeName" :value="item.id" />-->
      <!--            </el-select>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--      <el-row>-->
      <!-- </el-row> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button :disabled="editable" type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { arrayQuery } from '@/utils/utils';

export default {
  data () {
    return {
      rules: {
        templateName: [
          { required: true, message: '请输入模板活动名称', trigger: 'blur' }
        ],
        visibleRangeSelect: [
          {
            type: 'array',
            required: true,
            message: '请选择可见范围',
            trigger: 'change'
          }
        ]
      },
      dialogVisible: false,
      formData: {
        visibleRangeSelect: [],
        visibleRange: '',
        activityClassification: '行业模板活动',
        activityClassificationCode: 'AC_01'
      },
      activityGoalList: [],
      visibleRangeList: [
        {
          fieldValue: '员工',
          fieldKey: '1'
        },
        {
          fieldValue: '服务商',
          fieldKey: '2'
        }
      ],
      activityClassificationList:[
        {
          name:'行业模板活动',
          value:'AC_01'
        },
        {
          name:'区域活动',
          value:'AC_02'
        },
      ],
      // activityTypeList: [],
      // subdivideTypeList: [],
      agendaList: ['']
    };
  },
  props: {
    addTemplateDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    addTemplateDialogVisible (val) {
      if (val) {
        if (this.rowData.id) {
          this.formData = this.rowData;
          if (!this.rowData.visibleRange) {
            this.$set(this.formData, 'visibleRangeSelect', []);
          } else {
            if (this.rowData.visibleRange.toString() === '3') {
              this.$set(this.formData, 'visibleRangeSelect', ['1', '2']);
            } else {
              this.$set(this.formData, 'visibleRangeSelect', [
                `${this.rowData.visibleRange}`
              ]);
            }
          }
          if (this.formData.activityTypeCode) {
            this.subdivideTypeList = arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'id').subTypeList;
          } else {
            this.subdivideTypeList = [];
          }
          if (this.rowData.templateActivityAgendaList.length > 0) {
            this.agendaList = this.rowData.templateActivityAgendaList.map(item => {
              return item.agenda;
            });
          } else {
            this.agendaList = [''];
          }
        }
      } else {
        this.formData = {
          visibleRangeSelect: []
        };
        this.agendaList = [''];
        this.$nextTick(() => {
          this.$refs.addTemplateActivityFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    changeTemplateType(val){
      this.$refs.addTemplateActivityFrom.clearValidate();
      this.$set(this.formData, 'templateName', val === 'AC_02' ? '区域活动' : '行业模板活动');
      const activityClassification = this.activityClassificationList.find(item => item.value === val);
      this.$set(this.formData, 'activityClassification', activityClassification.name);
    },
    agendaDelBtn (index) {
      this.agendaList.splice(index, 1);
    },
    agendaAddBtn () {
      this.agendaList.push('');
    },
    visibleRangeSelectChange (e) {
      if (e.length > 1) {
        this.$set(this.formData, 'visibleRange', '3');
      } else {
        this.$set(this.formData, 'visibleRange', e[0]);
      }
    },
    submitHandlen () {
      this.$refs['addTemplateActivityFrom'].validate(valid => {
        if (valid) {
          // 活动类型名称过滤
          // if (this.formData.activityTypeCode) {
          //   this.formData.activityType = arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'id').typeName;
          // }
          // 细分活动类型名称过滤
          // if (this.formData.activitySubtypeCode) {
          //   this.formData.activitySubType = arrayQuery(this.formData.activitySubtypeCode, this.subdivideTypeList, 'id').typeName;
          // }
          // 活动议程数组处理
          let activityAgenda = this.agendaList.filter(item => item);
          this.formData.activityAgenda = activityAgenda.map((item, index) => {
            return {
              agenda: item,
              orderNum: index + 1
            };
          });
          if (this.formData.id) {
            this.$emit('editTemplateSubHandle', this.formData);
          } else {
            this.$emit('addTemplateSubHandle', this.formData);
          }
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    getActivityGoalList () {
      let params = ['activity_goal'];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityGoalList = res.data.activity_goal;
        }
      });
    }
  },
  mounted () {
    this.getActivityGoalList();
    // this.getActivityTypeList();
  }
};
</script>

<style scoped>
.agendaRow {
  position: relative;
}
.agendaRow + .agendaRow {
  margin-top: 10px;
}
.agendaRow ::v-deep .el-input{
  width: 80% !important;
}
</style>
